export default "__VITE_ASSET__C$dh2Qd2__"